$(document).on("turbolinks:load", function () {
    $("#company_name").on("keyup", function (e) {
        var name = $("#company_name").val();
        $("#company_welcome_message").val("Welcome to " + name + " App.");
    });
});